import { useRefEffect } from '@toss/react';
import { throttle } from 'lodash-es';

/** 스크롤 이벤트를 활용해서 다음 페이지 데이터를 불러오는 hooks */
export const useInfiniteScrollEvent = <E extends HTMLElement = HTMLElement>({
  hasNextPage,
  fetchNextPage,
  delayTime = 300,
}: {
  hasNextPage?: boolean;
  fetchNextPage: () => Promise<any>;
  delayTime?: number;
}) => {
  return useRefEffect(
    (container: E) => {
      if (!container) return;

      let fetching = false;
      const asyncHandler = throttle(async () => {
        const { scrollHeight, scrollTop, clientHeight } = container;
        if (!fetching && clientHeight * 1.2 > scrollHeight - scrollTop) {
          fetching = true;
          if (hasNextPage) await fetchNextPage();
          fetching = false;
        }
      }, delayTime);
      const handler = () => {
        void asyncHandler();
      };

      container.addEventListener('scroll', handler);
      return () => {
        asyncHandler.cancel();
        container.removeEventListener('scroll', handler);
      };
    },
    [hasNextPage, fetchNextPage],
  );
};
